import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DARK_MODE_ROLLOUT_EXPERIMENT = defineFcm('dark_mode_rollout_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Dark mode',
		description:
			'Maps a country and/or locale to the Experiment Service experiment name that ramps dark mode for that region. ' +
			'Configure per-country/per-locale entries in the admin console, each pointing at its own experiment ' +
			'(e.g. dark_mode_rollout_fr), so rollout percentage can be tuned independently per region without a deploy. ' +
			'No entry for a given country/locale means dark mode stays disabled there.',
		import: false,
		template: {
			experimentName: '',
		},
		supportedGroups: { countries: true, locales: true },
	});
